import React from "react";
import ListItem from "../baseListItems/baseList13";

const CustomizableList = ({
  items = [],
  width = "w-[320px]",
  className = "",
  gap = 2,
  renderRightComponent = () => null
}) => {
  return (
    <div className={`flex flex-col gap-${gap} ${className}`}>
      {items.map((item, index) => (
        <ListItem
          key={index}
          image={item.image}
          label={item.label}
          showLabel={item.showLabel !== false}
          title={item.title}
          showDescription={item.showDescription !== false}
          description={item.description}
          width={width}
        >
          {renderRightComponent(item, index)}
        </ListItem>
      ))}
    </div>
  );
};

export default CustomizableList;